import { Pipe, PipeTransform } from '@angular/core';
import { Time } from '../time/time';

@Pipe({
  name: 'printTime',
  standalone: false,
})
export class PrintTimePipe implements PipeTransform {
  transform(time: Time): string {
    if (time.hour < 0 || time.hour > 24 || time.minute < 0 || time.minute > 59) {
      return '';
    } else {
      const hours: string = time.hour < 10 ? '0' + time.hour.toString() : time.hour.toString();
      const minutes: string = time.minute < 10 ? '0' + time.minute.toString() : time.minute.toString();
      return hours.concat(' : ').concat(minutes);
    }
  }
}
